export default function PageShell({ children }) {
  return (
    <div className="max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8">
      {children}
    </div>
  );
}